import Styled from "styled-components";

export const Form = Styled.form`
margin-top: 20px;
margin: 0 7%;
margin-bottom: 100px;

@media(max-width: 800px) {
  margin: 0 2%;
  margin-bottom: 100px;
}

`;

export const H1 = Styled.h1`
text-align: center;
font-weight: bold;
font-size: 30px;
margin-top: 40px;
margin-bottom: 40px;

`;

export const ContainerCadastro = Styled.div`
text-align: center;
display: flex;
border-radius: 8px;
padding: 10px 0;
margin-bottom: 30px;


.icon{
    float: right;
    margin-right: 30px;
}

`;

export const Input = Styled.input`
width: 100%;
border: none;
outline: none;
margin-left: 10px;
::Placeholder{
    font-weight: bold;
    padding-left: 10px;
    font-size: 15px;
}
`;

export const Text = Styled.div`
margin-top: 20px;

.adress{
 
}

.house{
    color: rgba(5, 9, 34, 0.6);
}

.information{
    display: flex;
    flex-direction: column;
    color: var(--primary-color);
    font-family: var(--font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}
.default {
    font-size: 14px;
}
`;

export const Line = Styled.div`
margin-top: 20px;
margin-bottom: 20px;
border: solid 1px #F0F2F5;
`;

export const RegisterNewAddress = Styled.div`
display: flex;
flex-direction: column;
gap: 10px;
`;

export const Registration = Styled.p`

`;

export const ContainerInput = Styled.div`
display: flex;
justify-content: space-between;
.first{
    width: 47%; 
    height:100%;
}

.second{
    width: 47%;
    height:100%;
}
`;

export const Label = Styled.label`
display:block;
font-weight: bold;
`;

export const InputIEnjoy = Styled.input`
width: 100%;
height: 35px;
border-radius: 4px;
border: none;
outline: none;
`;

export const InputLarge = Styled.input`
width: 100%;
height: 35px;
border-radius: 4px;
border: none;
outline: none;
`;

export const ContainerInputDate = Styled.div`
width: 100%;
`;

export const InputDate = Styled.input`
width: 100%;
height: 35px;
border-radius: 4px;
border: none;
outline: none;
`;

export const ConfirmAndCancel = Styled.div`
text-align: right;
cursor: pointer;
text-decoration: underline;
flex-direction: column;
margin-top: 20px;
margin-bottom: 20px;
margin-right: 10px;
.confirm{
margin-right: 10px;
}

.cancel{
}
`;

export const RegisteredCards = Styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const CheckboxContainer = Styled.div`
margin-top: -30px;
display: flex;
align-items: center;

label{
    padding-left: 10px;
    cursor: pointer;
    line-height: 20px;
    width: 100%;
    &:active{
        color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
    }
}
`;

export const Radio = Styled.input`
`;
export const TitleProduct = Styled.p`
`;

export const SectionTitle = Styled.h2`
  color: var(--primary-color);
  font-family: var(--font-family);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

export const InputFieldsWrapper = Styled.div`
  .MuiInputBase-input {
    color: var(--primary-color) !important;
    font-family: var(--font-family) !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 150% !important;
  }
  .MuiInput-input::placeholder {
    color: var(--primary-color) !important;
    font-family: var(--font-family) !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 150% !important;
    opacity: 1;
  }
`;
